export function normalizeOccupancyRow(item, index) {
    const bellId =
        item?.bell_id ?? item?.bellId ?? item?.bellNumber ?? item?.bell_number ?? index + 1

    const teacherBusy = Boolean(item?.teacherBusy ?? item?.teacher_busy ?? false)
    const roomBusy = Boolean(item?.roomBusy ?? item?.room_busy ?? false)

    const groups = Array.isArray(item?.groups)
        ? item.groups.map((g) => ({
            id: String(g.id ?? g.group_id ?? g.groupId),
            isBusy: Boolean(g.isBusy ?? g.is_busy ?? false),
        }))
        : []

    const combinedBusy = teacherBusy || roomBusy || groups.some((g) => g.isBusy)

    return {
        bellId,
        bellNumber: item?.bellNumber ?? item?.bell_number ?? bellId,
        teacherBusy,
        roomBusy,
        groups,
        combinedBusy,
    }
}

export function buildOccupancyRows(bells, occupancyData) {
    const rowsByBell = new Map(
        occupancyData.map((row, index) => {
            const normalized = normalizeOccupancyRow(row, index)
            return [String(normalized.bellId), normalized]
        })
    )

    const bellsSource = bells.length > 0 ? bells : occupancyData

    return bellsSource.map((bell, index) => {
        const bellId =
            bell?.bell_id ?? bell?.bellId ?? bell?.bellNumber ?? bell?.bell_number ?? index + 1
        const mapped = rowsByBell.get(String(bellId))

        return {
            bellId,
            bellNumber: bell?.bellNumber ?? bell?.bell_number ?? bellId,
            teacherBusy: mapped?.teacherBusy ?? Boolean(bell?.teacherBusy ?? bell?.busy ?? bell?.isBusy),
            roomBusy: mapped?.roomBusy ?? Boolean(bell?.roomBusy ?? bell?.groupIsBusy),
            groups: mapped?.groups ?? [],
            combinedBusy:
                mapped?.combinedBusy
                ?? Boolean(
                    bell?.combinedBusy
                    ?? bell?.combined_busy
                    ?? bell?.busy
                    ?? bell?.isBusy
                    ?? mapped?.teacherBusy
                    ?? mapped?.roomBusy
                ),
        }
    })
}
